import { Input, Modal } from 'antd';
import React from 'react';

interface IProps {
  /** The current title, in the language being edited. */
  title: string;
  isRenameModalVisible: boolean;
  handleRenameOk: () => void;
  hideRenameModal: () => void;
  tempTitle: string;
  setTempTitle: React.Dispatch<React.SetStateAction<string>>;
}

const TitleModal: React.FC<IProps> = ({
  title,
  isRenameModalVisible,
  handleRenameOk,
  hideRenameModal,
  tempTitle,
  setTempTitle,
}) => {
  return (
    <Modal
      title={`Rename "${title}"`}
      open={isRenameModalVisible}
      onOk={handleRenameOk}
      onCancel={hideRenameModal}
    >
      <Input
        value={tempTitle}
        onChange={e => setTempTitle(e.target.value)}
        onPressEnter={handleRenameOk}
        required
      />
    </Modal>
  );
};

export default TitleModal;
